import { render, staticRenderFns } from "./ButtonUnpublish.vue?vue&type=template&id=009dc06e&scoped=true&"
import script from "./ButtonUnpublish.vue?vue&type=script&lang=js&"
export * from "./ButtonUnpublish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009dc06e",
  null
  
)

export default component.exports